module.exports = __webpack_public_path__ + "static/media/ant-smash.c1f5a2d6.jpg";